/**
 * Main Product Custom — Swiper.js gallery integration.
 * Uses Swiper from CDN (loaded in the liquid template).
 * Initialises: main swiper + thumbs swiper with syncing.
 */
(function () {
  'use strict';

  function initSwiper(sectionId) {
    var mainEl = document.getElementById('MPC-Swiper-' + sectionId);
    var thumbsEl = document.getElementById('MPC-Swiper-Thumbs-' + sectionId);
    var counterEl = document.getElementById('MPC-Swiper-Counter-' + sectionId);

    if (!mainEl) return;

    // Don't double-init
    if (mainEl.swiperInstance) return;

    var thumbsSwiper = null;

    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        watchSlidesVisibility: true,
        slideToClickedSlide: true
      });
    }

    var mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      autoHeight: true,
      navigation: {
        nextEl: '#MPC-Swiper-Next-' + sectionId,
        prevEl: '#MPC-Swiper-Prev-' + sectionId
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      on: {
        init: function () {
          updateCounter(this, counterEl);
        },
        slideChange: function () {
          updateCounter(this, counterEl);
        }
      }
    });

    mainEl.swiperInstance = mainSwiper;
    if (thumbsEl) thumbsEl.swiperInstance = thumbsSwiper;
  }

  function updateCounter(swiper, counterEl) {
    if (!counterEl) return;
    var current = counterEl.querySelector('.mpc-swiper-counter__current');
    if (current) {
      current.textContent = swiper.activeIndex + 1;
    }
  }

  // Init all on page load
  function initAll() {
    var galleries = document.querySelectorAll('.mpc-gallery[data-swiper-section]');
    galleries.forEach(function (gallery) {
      var sectionId = gallery.getAttribute('data-swiper-section');
      if (sectionId) {
        if (typeof Swiper === 'undefined') {
          setTimeout(function () { initSwiper(sectionId); }, 200);
          return;
        }
        initSwiper(sectionId);
      }
    });

    // Bind variant image switching
    bindVariantImageSync();
    // Bind custom variant UI syncing (runs after Shopify DOM swaps)
    bindCustomVariants();
    // Bind quantity bundle offers to the product form quantity
    bindBundles();
  }

  /**
   * Bundle offer radios set the quantity sent with the product form.
   * Uses the visible quantity selector when present, otherwise the
   * hidden input rendered inside the bundle block.
   */
  function bindBundles() {
    document.querySelectorAll('[data-mpc-bundles]').forEach(function (wrap) {
      if (wrap._mpcBundlesBound) return;
      wrap._mpcBundlesBound = true;

      var section = wrap.closest('.shopify-section') || document;
      var options = wrap.querySelectorAll('[data-mpc-bundle-qty]');

      function getQtyInput() {
        return section.querySelector('.quantity__input') || wrap.querySelector('[data-mpc-bundle-input]');
      }

      function select(option) {
        options.forEach(function (o) {
          var active = o === option;
          o.classList.toggle('mpc-bundle-option--active', active);
          o.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        var input = getQtyInput();
        if (input) {
          input.value = option.getAttribute('data-mpc-bundle-qty');
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      options.forEach(function (option) {
        option.addEventListener('click', function () { select(option); });
      });

      var initial = wrap.querySelector('.mpc-bundle-option--active') || options[0];
      if (initial) select(initial);
    });
  }

  /**
   * Listens for variant-selects change events and syncs custom UI.
   * The native label-for-radio behavior handles clicking —
   * we just sync the display after Shopify's product-info.js
   * fetches and swaps the DOM.
   */
  function bindCustomVariants() {
    // After Shopify swaps DOM on variant change, sync our custom UI
    document.addEventListener('change', function (e) {
      var vs = e.target.closest('variant-selects');
      if (!vs) return;
      // Delay so product-info.js finishes its internal update
      setTimeout(function () {
        syncVariantUI(vs);
      }, 100);
    });

    // Initial sync
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      setTimeout(function () { syncVariantUI(vs); }, 100);
    });
  }

  /**
   * Reads the currently checked radios inside a variant-selects and updates
   * all custom UI elements: selected-value spans, active pill/card classes.
   */
  function syncVariantUI(vs) {
    var sectionId = vs.getAttribute('data-section');
    if (!sectionId) return;

    // Update data-selected-value spans
    vs.querySelectorAll('[data-selected-value]').forEach(function (span) {
      var pos = span.getAttribute('data-option-position');
      if (!pos) return;
      var checkedRadio = vs.querySelector('.mpc-variant-radio[name$="-' + pos + '"]:checked');
      if (checkedRadio) {
        span.textContent = '— ' + checkedRadio.value;
      }
    });

    // Sync active states on pills
    vs.querySelectorAll('.mpc-variant-pill').forEach(function (pill) {
      var radioId = pill.getAttribute('for');
      var radio = document.getElementById(radioId);
      if (radio && radio.checked) {
        pill.classList.add('mpc-variant-pill--active');
      } else {
        pill.classList.remove('mpc-variant-pill--active');
      }
    });

    // Sync active states on cards
    vs.querySelectorAll('.mpc-variant-card').forEach(function (card) {
      var radioId = card.getAttribute('for');
      var radio = document.getElementById(radioId);
      if (radio && radio.checked) {
        card.classList.add('mpc-variant-card--active');
      } else {
        card.classList.remove('mpc-variant-card--active');
      }
    });
  }

  /**
   * When a variant is selected, slide the Swiper to the variant's featured image.
   */
  function bindVariantImageSync() {
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      if (vs._mpcVariantBound) return;
      vs._mpcVariantBound = true;

      vs.addEventListener('change', function () {
        var sectionId = vs.getAttribute('data-section');
        if (!sectionId) return;

        // Small delay so product-info.js has updated the DOM
        setTimeout(function () {
          var swiperEl = document.getElementById('MPC-Swiper-' + sectionId);
          if (!swiperEl || !swiperEl.swiperInstance) return;

          // Find the selected variant's featured_media ID from the variant-selects JSON
          var jsonEl = vs.querySelector('[data-variant-selects-json]');
          if (!jsonEl) return;
          try {
            var variants = JSON.parse(jsonEl.textContent);
            // Determine which variant is selected based on current radio states
            var selectedOptions = {};
            vs.querySelectorAll('.mpc-variant-radio:checked').forEach(function (radio) {
              selectedOptions[radio.getAttribute('data-option-name')] = radio.value;
            });

            // Find matching variant
            var selectedVariant = null;
            for (var i = 0; i < variants.length; i++) {
              var v = variants[i];
              var match = true;
              for (var j = 0; j < v.options.length; j++) {
                // Match by position since option names can vary
                var optionInputs = vs.querySelectorAll('.mpc-variant-radio[name$="-' + (j + 1) + '"]');
                var selectedVal = null;
                optionInputs.forEach(function (inp) {
                  if (inp.checked) selectedVal = inp.value;
                });
                if (selectedVal && v['option' + (j + 1)] !== selectedVal) {
                  match = false;
                  break;
                }
              }
              if (match) {
                selectedVariant = v;
                break;
              }
            }

            if (selectedVariant && selectedVariant.featured_media) {
              var mediaId = selectedVariant.featured_media.id;
              var slide = swiperEl.querySelector('[data-media-id="' + mediaId + '"]');
              if (slide) {
                var index = parseInt(slide.getAttribute('data-index'), 10);
                if (!isNaN(index)) {
                  swiperEl.swiperInstance.slideTo(index);
                }
              }
            }
          } catch (e) {
            // Silently fail — variant JSON parse issue
          }
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      watchForSwaps();
    });
  } else {
    initAll();
    watchForSwaps();
  }

  /**
   * product-info.js does a full DOM swap when variant changes.
   * We watch for variant-selects being replaced and re-init Swiper.
   */
  function watchForSwaps() {
    document.querySelectorAll('product-info').forEach(function (pi) {
      if (pi._mpcWatched) return;
      pi._mpcWatched = true;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            // variant-selects was replaced — re-init Swiper + bindings
            if (node.nodeType === 1 && node.matches && node.matches('variant-selects')) {
              var sectionId = node.getAttribute('data-section');
              if (sectionId) {
                setTimeout(function () {
                  initSwiper(sectionId);
                  syncVariantUI(node);
                  bindVariantImageSync();
                }, 150);
              }
            }
            // Also check for gallery inside added subtrees
            if (node.nodeType === 1 && node.querySelectorAll) {
              var galleries = node.querySelectorAll('.mpc-gallery[data-swiper-section]');
              galleries.forEach(function (g) {
                var sid = g.getAttribute('data-swiper-section');
                if (sid) {
                  setTimeout(function () { initSwiper(sid); }, 150);
                }
              });
            }
          });
        });
      });

      observer.observe(pi, { childList: true, subtree: true });
    });
  }

  // Shopify section load/unload
  document.addEventListener('shopify:section:load', function (event) {
    var sectionId = event.detail.sectionId;
    // Small delay to let DOM settle
    setTimeout(function () { initSwiper(sectionId); }, 100);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail.sectionId;
    var mainEl = document.getElementById('MPC-Swiper-' + sectionId);
    if (mainEl && mainEl.swiperInstance) {
      mainEl.swiperInstance.destroy(true, true);
      mainEl.swiperInstance = null;
    }
    var thumbsEl = document.getElementById('MPC-Swiper-Thumbs-' + sectionId);
    if (thumbsEl && thumbsEl.swiperInstance) {
      thumbsEl.swiperInstance.destroy(true, true);
      thumbsEl.swiperInstance = null;
    }
  });
})();
